import {
  IQuickReplyTemplate,
  QuickReplyTemplateData,
  QuickReplyTemplateErrorCode
} from 'shared/entities/quickReplyTemplate';
import { IField } from 'shared/entities/form';
import { INewList } from 'shared/entities/list';
import { ILoadingStageModel } from 'shared/entities/loadingStage';
import { LoadingStage } from 'shared/entities/meta';

export enum QuickReplyListPlaceholderKind {
  initialLoading = 'initialLoading',
  initialError = 'initialError',
  emptyCatalog = 'emptyCatalog',
  emptySearch = 'emptySearch'
}

export interface IQuickReplyTemplatesStore {
  readonly templates: INewList<IQuickReplyTemplate>;
  readonly searchQuery: IField<string>;
  readonly editingStage: ILoadingStageModel;
  readonly removingStage: ILoadingStageModel;
  readonly silentLoadingStage: LoadingStage;
  readonly canBeLoaded: boolean;
  readonly hasLoadedTemplates: boolean;

  /** Что показать вместо списка шаблонов (load / error / empty). null — есть items для списка. */
  resolvePlaceholder(
    filteredItemsCount: number
  ): QuickReplyListPlaceholderKind | null;

  load(): Promise<BaseResponse>;
  create(
    data: QuickReplyTemplateData
  ): Promise<
    BaseResponse<
      IQuickReplyTemplate,
      { errorCode: QuickReplyTemplateErrorCode | null }
    >
  >;
  update(
    id: string,
    data: QuickReplyTemplateData
  ): Promise<
    BaseResponse<
      IQuickReplyTemplate | null,
      { errorCode: QuickReplyTemplateErrorCode | null }
    >
  >;
  delete(
    id: string
  ): Promise<
    BaseResponse<null, { errorCode: QuickReplyTemplateErrorCode | null }>
  >;
  filterTemplates(query: string): IQuickReplyTemplate[];
  reset(): void;
}
